<template>
  <div>
    <div class="bold-text">Espèces</div>

    <div v-for="family in families" :key="family.id" class="mt-2">
      <b-link v-b-toggle="'family-collapse-'+family.id" class="m-1">
        {{ family.name }}
        <span class="when-open"><caret-down-icon size="18px"/></span>
        <span class="when-closed"><caret-up-icon size="18px"/></span>
      </b-link>

      <b-collapse :id="'family-collapse-'+family.id" visible>
        <b-form-checkbox
          class="checkbox-selectall"
          size="sm"
          v-model="selectedFamilies"
          :value="family.id"
          unchecked-value=""
          @change="toggleAllForFamily(family.id)"
        >
          Tout sélectionner
        </b-form-checkbox>
        <b-card>
          <b-form-checkbox-group
            class="checkbox-group"
            v-model="selectedSpeciess"
            :options="speciesForFamily(family.id)"
            @change="isAllFamilySpeciesSelected(family.id)"
            name="selected-species"
            stacked
          ></b-form-checkbox-group>
        </b-card>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {

  name: "SpeciesSelection",
  props: {

    families: {
      type: Array,
      required: true
    },

    speciess: {
      type: Array,
      required: true
    },

    initSelectedSpecies: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      selectedSpeciess: [],
      selectedFamilies:[],
    }
  },

  mounted() {
    if (this.initSelectedSpecies) {
      this.selectedSpeciess = this.initSelectedSpecies
    }
  },

  watch: {
    'selectedSpeciess': function (newValue, oldValue) {
      this.$emit('didChangeSelectedSpeciess', this.selectedSpeciess)
    }
  },

  methods: {

    speciesForFamily(familyId) {
      return this.speciess
        .filter(species => species.family.id === familyId)
        .map(species => ({
          value: species.id,
          text: species.name
        }))
    },

    toggleAllForFamily(familyId){
      let newTab = this.speciess.filter(species => species.family.id === familyId);
      let count = 0;
      newTab.forEach(species => {
        if(this.selectedSpeciess.includes(species.id)){
          count++;
        }
      });
      if(count === newTab.length) { //Tout supprimer
        newTab.forEach(species => {
           let index = this.selectedSpeciess.indexOf(species.id);
           this.selectedSpeciess.splice(index, 1);
        })
      }
      else if(count < newTab.length && count > 0) { //Merge
        newTab.forEach(species => {
          if(!this.selectedSpeciess.includes(species.id)){
             this.selectedSpeciess.push(species.id)
          }
        })
      }
      else { //Tout ajouter
        newTab.forEach(species => {
          this.selectedSpeciess.push(species.id)
        })
      }
    },

    isAllFamilySpeciesSelected(familyId){
        let newTab = this.speciess.filter(species => species.family.id === familyId);
        let count = 0;
        newTab.forEach(species => {
            if(this.selectedSpeciess.includes(species.id)){
                count++;
            }
        });
        if(count === newTab.length) {
          this.selectedFamilies.push(familyId)
        }
        else if (count < newTab.length){
          let index = this.selectedFamilies.indexOf(familyId)
          if(index >= 0) this.selectedFamilies.splice(index, 1)
        }
    }
  }
}
</script>

<style scoped>

  .checkbox-selectall {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: -10px;
    font-size: 0.9em;
  }

@media (min-width: 576px) {
  .checkbox-group {
    column-count: 2;
  }
}

@media (min-width: 768px) {
  .checkbox-group {
    column-count: 3;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/species/SpeciesSelection.vue